export class Client {

  public id: number;
  public name: string;
  public email: string;
  public callConfirmation: boolean;
  public canAccessSurveys: boolean;
  public canAccessPhotos: boolean;
  public canAccessReports: boolean;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/client.ts